


















import BaseComponent from '@/components/base-component.vue';
import { EnderecoParmDTO } from '@/interfaces/address';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class UiAutoCompleteAddress extends BaseComponent {
  @Prop({ default: 'Endereço' })
  public label: String;

  @Prop({ default: 'Digite o endereço' })
  public placeholder: String;

  @Prop({ default: () => [] })
  public rules?: any[];

  @Prop({ default: false })
  public required?: boolean;

  @Prop({ default: false })
  public onlyRegions?: boolean;

  @Prop({ default: false })
  public clearable?: boolean;

  @Prop({ default: false })
  public autofocus?: boolean;

  placeResult: any = {};
  autocomplete = null;
  dto: EnderecoParmDTO = null;

  mounted() {
    const input = document.getElementById('addressTextField') as HTMLInputElement;
    let types = this.onlyRegions ? ['(regions)'] : null;

    const options = {
      componentRestrictions: { country: 'br' },
      fields: ['address_components', 'formatted_address', 'place_id'],
      strictBounds: false,
      types: types
    };

    //@ts-ignore
    this.autocomplete = new google.maps.places.Autocomplete(input, options);
    this.autocomplete.addListener('place_changed', () => {
      this.onPlaceChanged();
    });
  }

  onPlaceChanged() {
    this.placeResult = this.autocomplete.getPlace();
    this.parse(this.placeResult);
  }

  parse(placeResult) {
    if (!placeResult) {
      this.$emit('input', null);
      this.$emit('change', null);
      return;
    }
    let acs = placeResult.address_components;

    if (!acs) {
      this.$emit('input', null);
      this.$emit('change', null);
      return;
    }

    let dto = new EnderecoParmDTO();
    acs.forEach((ac) => {
      const componentType = ac.types[0];

      switch (componentType) {
        case 'route': {
          dto.logradouro = ac.long_name;
          break;
        }

        case 'street_number': {
          dto.numero = ac.long_name;
          break;
        }

        case 'subpremise': {
          dto.complemento = ac.long_name;
          break;
        }

        case 'postal_code': {
          dto.cep = ac.long_name;
          break;
        }

        case 'sublocality_level_1': {
          dto.bairro = ac.long_name;
          break;
        }

        case 'administrative_area_level_2': {
          dto.municipio = ac.long_name;
          break;
        }

        case 'administrative_area_level_1': {
          dto.estado = ac.short_name;
          break;
        }
      }
    });

    dto.googlePlaceId = placeResult.place_id;
    dto.googleEnderecoFormatado = placeResult.formatted_address;
    this.dto = dto;
    this.$emit('input', this.dto);
    this.$emit('change', this.dto);
  }

  onClearClick() {
    this.$emit('input', null);
    this.$emit('change', null);
  }

  onChange() {
    if (!this.placeResult || !this.placeResult.formatted_address) {
      this.$emit('input', null);
      this.$emit('change', null);
    }
  }
}
